import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useI18n } from "../contexts/I18nContext";
import useScrollReveal from "../hooks/useScrollReveal";

export default function SignupPage() {
  const { signup } = useAuth();
  const { t } = useI18n();
  const navigate = useNavigate();
  const revealRef = useScrollReveal();
  const [form, setForm] = useState({ name: "", email: "", password: "", company: "", phone: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (form.password.length < 6) { setError(t.signup_pwError); return; }
    setLoading(true);
    try {
      await signup(form);
      navigate("/dashboard");
    } catch (err) {
      setError(err.response?.data?.error || t.signup_error);
    } finally {
      setLoading(false);
    }
  };

  const set = (key) => (e) => setForm({ ...form, [key]: e.target.value });

  return (
    <div ref={revealRef} className="dept-auth-page">
      <div className="dept-auth-shell page-enter">
        <div className="dept-auth-heading">
          <span>회원 서비스</span>
          <h1>{t.signup_heading}</h1>
          <p>{t.signup_subtitle}</p>
        </div>

        {error && <div className="dept-auth-error">{error}</div>}

        <form onSubmit={handleSubmit} className="dept-auth-form">
          <div className="dept-auth-field">
            <label>{t.signup_name}</label>
            <input type="text" required value={form.name} onChange={set("name")}
              placeholder={t.signup_namePlaceholder} />
          </div>
          <div className="dept-auth-field">
            <label>{t.signup_email}</label>
            <input type="email" required value={form.email} onChange={set("email")}
              placeholder="example@email.com" />
          </div>
          <div className="dept-auth-field">
            <label>{t.signup_password}</label>
            <input type="password" required value={form.password} onChange={set("password")}
              placeholder={t.signup_pwPlaceholder} />
          </div>
          <div className="dept-auth-field">
            <label>{t.signup_company}</label>
            <input type="text" value={form.company} onChange={set("company")}
              placeholder={t.signup_companyPlaceholder} />
          </div>
          <div className="dept-auth-field">
            <label>{t.signup_phone}</label>
            <input type="tel" value={form.phone} onChange={set("phone")}
              placeholder={t.signup_phonePlaceholder} />
          </div>
          <label className="flex items-start gap-2 text-sm leading-6">
            <input type="checkbox" required className="mt-1.5" />
            <span><Link to="/terms" target="_blank" className="underline">이용약관</Link>에 동의합니다. (필수)<br /><Link to="/privacy" target="_blank" className="underline">개인정보처리방침</Link>에서 회원 정보의 처리 목적과 보유기간을 확인할 수 있습니다.</span>
          </label>
          <button type="submit" disabled={loading} className="dept-auth-submit">
            {loading ? t.signup_submitting : t.signup_emailSignup}
          </button>
        </form>

        <p className="dept-auth-switch">
          {t.signup_hasAccount}{" "}
          <Link to="/login">{t.signup_login}</Link>
        </p>
      </div>
    </div>
  );
}
